/**
 * 資料用 画像フィールド — ランディングと同じ ImageFieldEditor / ImageGalleryDialog を
 * `documents/imgs` Storage プールに向けて使う。
 */
import { ImageFieldEditor } from '@/pages/landings/components/ImageFieldEditor';

interface Props {
  label: string;
  value: string | null;
  onChange: (v: string | null) => void;
}

export function DocumentImageField({ label, value, onChange }: Props) {
  return (
    <ImageFieldEditor
      label={label}
      value={value}
      onChange={onChange}
      storagePath="documents/imgs"
    />
  );
}
